/* eslint-disable */

/**
 * Policy on which fees customers pay and the benefits they receive by paying them. Customers must
 * accept a rate plan before its fees are imposed.
 */
export enum RatePlan {
  /**
   * UNDECIDED - Indicates that a rate plan has yet to be selected for a new customers after Cash Pro launch.
   *
   * For cases where the rate plan cannot yet be selected (i.e. using an old version of the apps)
   * this is treated as PERSONAL.
   */
  UNDECIDED = "UNDECIDED",
  /**
   * UNDECIDED_DEFERRED - Placeholder rate plan for experimental cases where we defer rate plan selection in onboarding.
   *
   * Treated much the same as UNDECIDED and PERSONAL.
   * See also Experiments.OrganicNewCustomerRatePlanSelectionPolicy.
   */
  UNDECIDED_DEFERRED = "UNDECIDED_DEFERRED",
  /**
   * UNDECIDED_GRANDFATHERED - Rate plan for customers who joined before the Cash Pro release or after
   * the release using an older version of the apps (prior to Cash Pro).
   * In some situations these customers will be presented the rate plan or usage reason blocker.
   */
  UNDECIDED_GRANDFATHERED = "UNDECIDED_GRANDFATHERED",
  /**
   * PERSONAL - Payments are free, but limited in nature (no business transactions) and volume (strict limits,
   * even for identity-verified customers). Received payments count against the sender's limits.
   */
  PERSONAL = "PERSONAL",
  /**
   * BUSINESS - Deprecated. Use BUSINESS_1_5 or BUSINESS_1_9 instead.
   *
   * @deprecated
   */
  BUSINESS = "BUSINESS",
  /**
   * BUSINESS_0 - Customers with $0 fee promotion that would otherwise have been BUSINESS_2_75. They are neither
   * limited in nature (business transactions are permitted), nor are they limited in volume
   * (though identity verification is still required). Received payments do not count against the
   * sender's limits.
   */
  BUSINESS_0 = "BUSINESS_0",
  /**
   * BUSINESS_1_5 - Received payments cost 1.5%.
   * This rate plan is only for grandfathered business customers who joined as business before
   * we changed our business fee to 1.9%.
   */
  BUSINESS_1_5 = "BUSINESS_1_5",
  /**
   * BUSINESS_1_9 - Received payments cost 1.9%. They are neither limited in nature (business transactions are
   * permitted), nor are they limited in volume (though identity verification is still required).
   * Received payments do not count against the sender's limits.
   */
  BUSINESS_1_9 = "BUSINESS_1_9",
  /**
   * BUSINESS_2_75 - Received payments cost 2.75%. They are neither limited in nature (business transactions are
   * permitted), nor are they limited in volume (though identity verification is still required).
   * Received payments do not count against the sender's limits.
   */
  BUSINESS_2_75 = "BUSINESS_2_75",
  /**
   * BUSINESS_NONPROFIT - Rate plan for nonprofit organizations. In most situations, they are treated the same as
   * businesses. Non-profits have a slightly different experience when it comes to notifications
   * and payment details. Non-profits are also given access to data about their donors.
   */
  BUSINESS_NONPROFIT = "BUSINESS_NONPROFIT",
  /**
   * BUSINESS_MERCHANT - P2P is free, Instant Deposit is 3.75%. Slow Deposit is 2.25%. They are neither limited in
   * nature (business transactions are permitted), nor are they limited in volume (though identity
   * verification is still required). Received payments do not count against the sender's limits.
   * This should be the default for all new business customers and existing business customers
   * should be eventually migrated.
   */
  BUSINESS_MERCHANT = "BUSINESS_MERCHANT",
  /**
   * BUSINESS_2_60 - Received payments cost 2.6% + $0.15. They are neither limited in nature (business transactions
   * are permitted), nor are they limited in volume (though identity verification is still
   * required). Received payments do not count against the sender's limits.
   */
  BUSINESS_2_60 = "BUSINESS_2_60",
}
